import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-producer-reports',
    templateUrl: './producer-reports.component.html',
    styleUrls: ['./producer-reports.component.scss'],
    standalone: false
})
export class ProducerReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
